export default __webpack_public_path__ + "static/media/arrow.c43f348e.svg";